import { React, useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { useLanguage } from '../../../../Context/LanguageContext';
import { useTheme } from '../../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../../Styles/theme';
import moment from 'moment';

import FetchModule from '../../../Share/Network/FetchModule';

import MemberShipHistoryInfoButtonImagePath from '../../../../image/MemberShipHistoryInfoButton.png';
import LessonReserveHistoryDeleteModal from './Modal/LessonReserveHistoryDeleteModal';

const CourseHistoryInfoView = (props) => {
  const { data, /*reserveRerendering*/ rendering } = props;
  const { t, isEng } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const history = useHistory();

  const [isClicked, setIsClicked] = useState(false);
  const [state, setState] = useState('예약중');
  const [isAvailableExit, setIsAvailableExit] = useState(false);
  const [isAbsent, setIsAbsent] = useState(false);
  const [isLate, setIsLate] = useState(false);
  const [isAttendance, setIsAttendance] = useState(false);
  const [isClickedDeleteHistory, setIsClickedDeleteHistory] = useState(false);

  const OptionBoxRef = useRef();
  const OptionButtonRef = useRef();

  useEffect(() => {
    if (isClicked) {
      OptionBoxRef.current.style.height = `144px`;
      OptionBoxRef.current.style.border = `1px solid ${theme.primary}`;
    }
    else {
      OptionBoxRef.current.style.height = `0px`;
      OptionBoxRef.current.style.border = `0px solid ${theme.primary}`;
    }
  }, [isClicked])

  useEffect(() => {
    if (data.status === 0) {
      if (moment(data.classDate.split('T')[0] + "T" + data.classTime.split('-')[0] + ':00').isAfter(moment())) {
        setState(t('memberDetail.statusReserved'));
        setIsAvailableExit(true);
        setIsAbsent(true);
        setIsLate(true);
        setIsAttendance(true);
      }
      else {
        setState(t('memberDetail.statusAbsent'));
        setIsAvailableExit(true);
        setIsAbsent(false);
        setIsLate(true);
        setIsAttendance(true);
      }
    }
    else if (data.status === 1) {
      setState(t('memberDetail.statusAttended'));
      setIsAvailableExit(true);
      setIsAbsent(true);
      setIsLate(true);
      setIsAttendance(false);
    }
    else if (data.status === 2) {
      setState(t('memberDetail.statusLate'));
      setIsAvailableExit(true);
      setIsAbsent(true);
      setIsLate(false);
      setIsAttendance(true);
    }
    else if (data.status === 3) {
      setState(t('memberDetail.statusAbsent'));
      setIsAvailableExit(true);
      setIsAbsent(false);
      setIsLate(true);
      setIsAttendance(true);
    }
  }, [data])

  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [])

  function onClickOutSide(e) {
    if (OptionBoxRef.current !== e.target && OptionButtonRef.current !== e.target) {
      setIsClicked(false);
    }
  }

  function mouseOver() {
    OptionButtonRef.current.style.opacity = 1;
  }

  function mouseLeave() {
    OptionButtonRef.current.style.opacity = 0;
  }

  function onClickChangeState(state) {
    if (!isAttendance && state === 1) return;
    else if (!isLate && state === 2) return;
    else if (!isAbsent && state === 3) return;

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('reserve/modify/' + data.id + '/' + state, 'POST');

        if (responseData.status === 200) /*reserveRerendering();*/ rendering();
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }

  function onClickDeleteLessonReservation() {
    if (!isAvailableExit) return;

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('reserve/delete/manage/' + data.id, 'POST');

        if (responseData.status === 200) rendering();
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }

  return (
    <TopLevelWrapper onMouseOver={mouseOver} onMouseLeave={mouseLeave}>
      {isClickedDeleteHistory && <LessonReserveHistoryDeleteModal exitClickFn={() => setIsClickedDeleteHistory(false)} deleteClickFn={onClickDeleteLessonReservation} />}
      <ComponentWrapper isExistLessonNote={data.lessonNote !== ''} $isDark={isDark}>
        <Table>
          <Body>
            <Tr style={{ width: '89px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '91px' }}>
                  <Text>{isEng ? moment(data.classDate).format(t('partnerGym.history.dateFormat')) : data.classDate.replaceAll('-', '.').slice(2, 10)}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr style={{ width: '214px', paddingLeft: '30px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '214px' }}>
                  <Text>{{ '일반방문': t('memberDetail.dataGeneralVisit'), '일반 방문': t('memberDetail.dataGeneralVisit') }[data.lessonName] || data.lessonName}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr style={{ width: '87px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '58px' }}>
                  <Text>{data.classTime.slice(0, 5)}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr style={{ width: '80px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '80px' }}>
                  <Text>{{ '없음': t('memberDetail.dataNone') }[data.teacherName] || data.teacherName}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr style={{ width: '185px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '129px' }}>
                  <Text>{data.memberShipName}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr style={{ width: '82px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '14px' }}>
                  <Text>{data.deduction}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr style={{ width: '180px' }}>
              <Td>
                <TextWrapper style={{ maxWidth: '160px' }}>
                  <Text>{state}</Text>
                </TextWrapper>
              </Td>
            </Tr>
            <Tr>
              <Td>
                <OptionButton ref={OptionButtonRef} src={MemberShipHistoryInfoButtonImagePath} onClick={() => setIsClicked(!isClicked)} />
                <OptionWrapper ref={OptionBoxRef}>
                  <Option isAvailable={isAvailableExit} onMouseDown={() => setIsClickedDeleteHistory(true)}>{t('memberDetail.btnDeleteHistory')}</Option>
                  <Option isAvailable={isAttendance} onMouseDown={() => onClickChangeState(1)}>{t('memberDetail.optMarkAttended')}</Option>
                  <Option isAvailable={isLate} onMouseDown={() => onClickChangeState(2)}>{t('memberDetail.optMarkLate')}</Option>
                  <Option isAvailable={isAbsent} onMouseDown={() => onClickChangeState(3)}>{t('memberDetail.optMarkAbsent')}</Option>
                </OptionWrapper>
              </Td>
            </Tr>
          </Body>
        </Table>
      </ComponentWrapper>
      {
        data.lessonNote !== '' &&
        <LessonNoteBox>
          <PreText fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{data.lessonNote}</PreText>
        </LessonNoteBox>
      }
    </TopLevelWrapper>
  )
};

export default CourseHistoryInfoView;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-end;

  width: 1018px;
`;

const LessonNoteBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 10px 20px;

  width: calc(93.9% - 40px);

  border-radius: 0px 0px 10px 10px;
  background-color: ${props => props.theme.buttonFill};
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
  height: 50px;

  background: ${props => props.theme.subBackground};

  box-shadow: ${props => props.$isDark ? 'none' : '0px 40px 50px rgba(240, 232, 227, 0.5)'};
  border: 1px solid ${props => props.theme.subBackground};
  border-radius: ${props => props.isExistLessonNote ? `30px 30px 0px 30px` : `30px`};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
      border: 1px solid ${props => props.theme.primary};
    }
  }
`;

const Table = styled.table`
  display: flex;
  flex-direction: row;
`;

const Body = styled.tbody`
  display: flex;
  flex-direction: row;

  margin-left: 28px;
`;

const Tr = styled.tr`
  display: flex;
  flex-direction: row;
`;

const Td = styled.td`
  display: flex;
  flex-direction: row;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: flex-start;

  overflow: hidden;

  max-height: 20px;
`;

const Text = styled.span`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;
  padding: 0 0 0 0;
`;

const OptionButton = styled.img`
  opacity: 0;

  transition: all 0.3s ease-in-out;
`;

const OptionWrapper = styled.div`
  position: absolute;

  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  overflow: hidden;

  margin-top: 40px;
  margin-left: -20px;

  z-index: 5;

  border-radius: 8px;

  transition: all 0.2s ease-in-out;
`;

const Option = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 78px;
  height: 36px;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.isAvailable ? props.theme.primary : props.theme.subText};
  background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
      color: ${props => props.isAvailable ? props.theme.subBackground : props.theme.subText};
      background-color: ${props => props.isAvailable ? props.theme.primary : props.theme.subBackground};
    }
  }
`;

const PreText = styled.pre`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  padding: 0 0 0 0;

  white-space: pre-wrap;
  word-break: break-word;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }
`;
